import { render, staticRenderFns } from "./TableColumnSet.vue?vue&type=template&id=a6bf6dcc&scoped=true&"
import script from "./TableColumnSet.vue?vue&type=script&lang=js&"
export * from "./TableColumnSet.vue?vue&type=script&lang=js&"
import style0 from "./TableColumnSet.vue?vue&type=style&index=0&id=a6bf6dcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bf6dcc",
  null
  
)

export default component.exports